// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2799":"f6eacb60","2990":"a7957d2c","3628":"60d9f943","4340":"60d9f943","7797":"20f02157"}[chunkId] + ".chunk.css";
};